<template>
  <div>
    <h2 class="m-b-20 section-title">{{ label }}</h2>
    <div class="card m-b-30">
      <div class="row">
        <div>
          <GoodsType
            :value="3"
            @activeGoodsType="activeGoodsType"
          />
        </div>
      <!-- PACKAGE OPTIONS -->
      <div>
        <div class="row m-b-25">
          <div class="col-xs-1" v-if="showColliAmount">
            <InputText
              :label="$t('Colli')"
              v-model="value.colli"
              :options="numbers"
              :rules="{required: true}"/>
          </div>
          <div :class="calcPalletTypeClass">
           <InputSelect
             v-if="get_pallet_options.length > 0"
              :label="$t('type')"
              v-model="value.palleteType"
              @change="palletTypeSelected"
              :options="get_pallet_options"
              :rules="{required: true}"/>
          </div>
          <div :class="'col-xs-5'">
            <DimensionsSelect
              v-model="value.dimensions" />
          </div>
          <div :class="'col-xs-2'">
            <WeightSelect
              :label="`${$t('weight_per')} ${$t('pallet').toLocaleLowerCase()}`"
              v-model="value.colliWeight"
              :rules="{required: true}"/>
          </div>
        </div>
        <div class="row m-b-25">
          <div class="col-xs-5" v-if="showColliDescription">
            <DescriptionPicker
              :label="$t('desc')"
              v-model="value.description"
            />
          </div>
          <div :class="calcPalletExchangeClass">
            <PalletExchange
              :label="$t('LBL_EXCHANGE_PALLET')"
              v-model="value.palletExchange"
              :colli="value.colli"
              :selected-pallet-id="value.palleteType"
              :goods-type="value.goodsType"
              :disabled="isOneTimePalletSelected"
              @change="palletExchangeUpdated($event)"
              :rules="{required: false}"
            />
          </div>
          <div :class="calcPalletStackedClass">
            <InputSelect
              :label="$t('Stackable')"
              v-model="value.pallet_stackable_type"
              @change="stackSelected"
              :options="stackOptions"
              :rules="{required: true}"/>
          </div>
          <div class="col-xs-2" v-if="value.pallet_stackable_type === 'stacked'">
            <InputText
              :label="$t('Pallet space')"
              v-model="value.palletSpace"
              :rules="{required: true}"/>
          </div>
        </div>
        <div v-if="showColliContent">
        <div class="separator"></div>
        <!-- CONTENT ROW -->
        <div class="row m-b-30">
          <h2 class="col-xs-12 content-title m-b-20">{{ $t('content_title_pallet') }}</h2>
          <div class="col-xs-12">
            <ContentRow
              :showOnlyDescription="showOnlyDescription"
              :showOrigin="showOrigin"
              :showCustoms="showCustoms"
              :isCustomsInvoiceUploaded="isCustomsInvoiceUploaded"
              :class="value.content.length > (index + 1) ? 'm-b-20' : ''"
              v-for="(item, index) in value.content" :key="`row-${index}`"
              :deletable="value.content.length > 1"
              @setProductDetails="productSelected"
              @removeProduct="productRemoved"
              @quantityChange="quantityChange"
              :indexInData="index"
              @deleteRow="deleteRow"
              v-model="value.content[index]"
            />
          </div>
        </div>
        </div>
      </div>
      <div class="separator" v-if="removable"></div>
      <!-- CONTENT ROW OPTIONS -->
      <div class="clear-float">
        <div class="col-xs-6">
          <Btn
            v-if="showColliContent"
            @click.native="addContentItem"
            class="brand float-left m-r-20"
            :icon="{
            name: 'plus',
            size: '20',
          }"
            :btnText="$t('Add content')"
          />
          <Btn
            v-if="removable"
            @click.native="removePallete"
            class="gray float-left m-r-20"
            :icon="{
            name: 'deleteForever',
            size: '18',
          }"
            :btnText="$t('Remove pallete')"
          />
        </div>
        <div
          v-if="!useContentOnShipmentLevel && value.content[0]"
          class="col-xs-6 float-right"
          style="text-align: right; padding-top: 5px">
          <p>{{ $t('total_value')}} {{ totalContentAmount | currency(null, value.content[0].unitValue.unit.toUpperCase()) }}</p>
        </div>
      </div>

        <booking-dg-block
          v-if="!useContentOnShipmentLevel"
          :value="value"
          :custom-id="customId"
          :dg-type-shown-on-package-custom-id="dgTypeShownOnPackageCustomId"
          :show-temperature="showTemperature"
          :show-dangerous-goods="showDangerousGoods"
          @input="$emit('input', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import mixin from '@/mixins/mixins.js';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import DimensionsSelect from '@/components/elements/inputs/dimensionsSelect.vue';
import WeightSelect from '@/components/elements/inputs/weightSelect.vue';
import Toggle from "@/components/elements/inputs/toggle.vue";

import ContentRow from "@/components/shipments/contentRow.vue";
import DangerousGoodsBlock from "@/components/shipments/dangerousGoodsBlock";
import GoodsType from "@/components/shipments/goodsType.vue";
import productSelect from "@/mixins/productSelect";
import ProductPicker from "@/components/global/productPicker/productPicker.vue";
import BookingDgBlock from "@/components/shipments/bookingDgBlock.vue";
import PalletExchange from "../elements/inputs/palletExchange.vue";
import palletExchange from "../elements/inputs/palletExchange.vue";
import DescriptionPicker from "@/components/global/productPicker/descriptionPicker.vue";

export default {
  name: 'PalleteBlock',
  mixins: [mixin,productSelect],
  components: {
    DescriptionPicker,
    PalletExchange,
    BookingDgBlock,
    ProductPicker,
    GoodsType,
    Btn,
    InputSelect,
    InputText,
    Toggle,
    DimensionsSelect,
    WeightSelect,
    ContentRow,
    DangerousGoodsBlock
  },
  props: {
    useContentOnShipmentLevel: {
      type: Boolean,
      default: true,
    },
    isCustomsInvoiceUploaded: {
      type: Boolean,
      default: false,
    },
    dgTypeShownOnPackageCustomId: {
      type: String,
      default: '',
    },
    showColliAmount: {
      type: Boolean,
      default: false,
    },
    showColliDescription: {
      type: Boolean,
      default: true,
    },
    showColliContent: {
      type: Boolean,
      default: false,
    },
    showTemperature: {
      type: Boolean,
      default: false,
    },
    showDangerousGoods: {
      type: Boolean,
      default: false,
    },
    customId: {
      type: String,
      default: '',
    },
     label: {
      type: String,
      default: 'Pallet',
    },
    removable: {
      type: Boolean,
      default: false,
    },
    showOrigin: {
      type: Boolean,
      default: false,
    },
    showCustoms: {
      type: Boolean,
      default: false,
    },
    showOnlyDescription: {
      type: Boolean,
      default: false,
    },
    indexNo: {
      type: String,
    },
    value: {
      type: Object,
      default: () => {
        return{
          goodsType: 3,
          colli: 1,
          description: '',
          palleteType: '',
          palleteExchange: null,
          colliWeight: {
            value: 0,
            unit: 'kg',
          },
          dimensions: {
            width: {
              value: 0,
              disabled: false,
            },
            height: {
              value: 0,
              disabled: false,
            },
            length: {
              value: 0,
              disabled: false,
            },
            dimensionsType: 'cm',
          },
          isTemperature: false,
          minTemperature: '',
          maxTemperature: '',
          // stackablePallets: true,
          palletSpace: '',
          pallet_stackable_type: 'stackable',
          isDgToggleActive: false,
          qty: 1,
          Q: '',
          packingType: '',
          packingTypeOption: 2,
          isOverpack: 0,
          allPackedInOne: 2,
          iataLimitations: '',
          iataRadioactive: '',
          iataAdditionalInfo: '',
          dangerousGoodsServices: [
            {
              feeWrapperId: null,
              dangerousGoodsId: '',
              nemWeight: {
                unit: 'kg',
                value: null,
              },
              netWeight: {
                unit: 'kg',
                value: null,
              },
              bruttoWeight: {
                unit: 'kg',
                value: null,
              },
              englishTechnicalDesignation: '',
              danishTechnicalDesignation: '',
              iataAutorization: '',
              flashPoint: '',
              segregationGroup: '',
              ems: '',
              notAllInOneQty: '',
              notAllInOneOuterPackaging: '',
              innerPackaging: '',
              innerPackagingQty: '',
              packingInstruction: '',
              isEnvironmentalHazard: false,
              isMarinePollutant: false,
              isLimitedQuantity: false,
              isExceptedQuantity: false
            }
          ],
          content: [
            {
              qty: 1,
              description: '',
              unitWeight: {
                unit: 'kg',
                value: '',
              },
              unitValue: {
                value: '',
                unit: 'dkk',
              },
              hsCode: '',
              origin: '',
            },
          ],
        }
      },
    },
  },
  data() {
    return {
      totalContentAmount: 0,
      stackOptions: [
        {text: this.$t('Stacked'), value: 'stacked'},
        {text: this.$t('Stackable'), value: 'stackable'},
        {text: this.$t('Non-Stackable'), value: 'non_stackable'},
      ],
    };
  },
  created() {
    this.totalContentAmount = this.calculateTotalContentAmount(this.value.content);
    this.$store.dispatch('GET_PALLETE_TYPES').then((res) => {
      if (parseInt(this.value.palleteType) === 5019) return; //'Pallet - unspecified'
      const packaging = this.findPackagingById(res, this.value.palleteType);
      if (!packaging) return;

      let weight = packaging.weight;
      let height = packaging.height;
      if (this.get_editing_shipment?.storeShipmentPackages[this.indexNo]?.dimensions) {
        const packageHeight = this.get_editing_shipment?.storeShipmentPackages[this.indexNo]?.dimensions.height.value;
        if (this.shouldUseShipmentMeasure(packageHeight)) {
          height = packageHeight;
        }
      }

      if (this.get_editing_shipment?.storeShipmentPackages[this.indexNo]?.colliWeight) {
        const packageWeight = this.get_editing_shipment?.storeShipmentPackages[this.indexNo]?.colliWeight.value;
        if (this.shouldUseShipmentMeasure(packageWeight) && weight) {
          weight = packageWeight;
        }
      }

      this.$emit('input', {
        ...this.value,
        dimensions: {
          width: {
            value: packaging.width,
            disabled: !packaging.is_width_open
          },
          height: {
            value: height ? height : this.value.dimensions.height.value,
            disabled: false//Always open -- OLD; packaging.height ? !packaging.is_height_open : this.value.dimensions.height.disabled
          },
          length: {
            value: packaging.length,
            disabled: !packaging.is_length_open,
          },
          dimensionsType: 'cm',
        },
        colliWeight: {
          unit :  packaging?.weight_measure ? packaging.weight_measure : this.value.colliWeight.unit,
          value : weight ? weight : this.value.colliWeight.value,
        }
      });
    });
  },
  computed: {
    isOneTimePalletSelected() {
      return [5016, 5017, 5018].includes(parseInt(this.value.palleteType));
    },
    calcPalletExchangeClass() {
      if (!this.showColliDescription) {
        if (this.value.pallet_stackable_type === 'stacked') {
          return 'col-xs-5'
        }
        return 'col-xs-6'
      } else {
        if (this.value.pallet_stackable_type === 'stacked') {
          return 'col-xs-3'
        }
        return 'col-xs-4'
      }

    },
    calcPalletTypeClass() {
      if (this.showColliAmount) {
        return 'col-xs-4'
      }

      return 'col-xs-5'
    },
    calcPalletStackedClass() {
      if (!this.showColliDescription) {
        if (this.value.pallet_stackable_type === 'stacked') {
          return 'col-xs-5'
        }

        return 'col-xs-6'
      } else {
        if (this.value.pallet_stackable_type === 'stacked') {
          return 'col-xs-2'
        }

        return 'col-xs-3'
      }
    },
    ...mapGetters([
      'get_pallet_types',
      'get_pallet_options',
      'get_editing_shipment'
    ]),
  },
  methods: {
    findPackagingById(res, id) {
      return res.filter((g) => parseInt(g.id) === parseInt(id))[0];
    },
    stackSelected(val) {
      this.$emit('input', {
        ...this.value,
        pallet_stackable_type: val,
      });
    },
    addContentItem(){
      let weightUnit = 'kg';
      let currencyUnit = 'dkk';
      if (this.value.content.length) {
        weightUnit = this.value.content[0].unitWeight.unit;
        currencyUnit = this.value.content[0].unitValue.unit;
      }
      this.$emit('input', {
        ...this.value,
        content: [...this.value.content, {
          qty: 1,
          description: '',
          unitWeight: {
            value: '',
            unit: weightUnit,
          },
          unitValue: {
            value: '',
            unit: currencyUnit,
          },
          hsCode: '',
          origin: '',
        }]
      });
    },
    palletTypeSelected(packagingId) {
      const packaging = this.findPackagingById(this.get_pallet_types, packagingId);
      if (!packaging) return;

      let weight = packaging.weight;
      let height = packaging.height;
      if (this.get_editing_shipment?.storeShipmentPackages[this.indexNo]?.dimensions) {
        const packageHeight = this.get_editing_shipment?.storeShipmentPackages[this.indexNo]?.dimensions.height.value;
        if (this.shouldUseShipmentMeasure(packageHeight)) {
          height = packageHeight;
        }
      }

      if (this.get_editing_shipment?.storeShipmentPackages[this.indexNo]?.colliWeight) {
        const packageWeight = this.get_editing_shipment?.storeShipmentPackages[this.indexNo]?.colliWeight.value;
        if (this.shouldUseShipmentMeasure(packageWeight)) {
          weight = packageWeight;
        }
      }

      const isOneTime = parseInt(packaging.id) === 5016;
      this.$emit('input', {
        ...this.value,
        palleteType: packaging.id,
        packagingName: packaging.name,
        palleteExchange: isOneTime ? null : this.value.palleteExchange,
        dimensions: {
          width: {
            value: packaging.width,
            disabled: !packaging.is_width_open,
          },
          height: {
            value: height ? height : this.value.dimensions.height.value,
            disabled: false//Always open -- OLD; packaging.height ? !packaging.is_height_open : this.value.dimensions.height.disabled
          },
          length: {
            value: packaging.length,
            disabled: !packaging.is_length_open,
          },
          dimensionsType: packaging.dimension_type || 'cm',
        },
        colliWeight: {
          unit :  packaging?.weight_measure ? packaging.weight_measure : this.value.colliWeight.unit,
          value : weight ? weight : this.value.colliWeight.value,
        }
      });
    },
    palletExchangeUpdated(palletExchange) {
      this.$emit('input', {
        ...this.value,
        palleteExchange: palletExchange,
      })
      this.$emit('palletExchangeUpdated', true)
    },
    removePallete() {
      this.$emit('removePallet');
    },
    deleteRow(index) {
      this.$emit('input', {
        ...this.value,
        content: this.value.content.filter((item, idx) => idx !== index),
      });
    },
    activeGoodsType(val) {
      this.$emit('activePackageGoodsType', val);
    },
  },
  watch: {
    'showColliContent' (newVal, oldVal) {
      if (this.value && newVal && this.value.content.length < 1) {
        this.addContentItem()
      }
    },
    'value.content': {
      handler(newVal){
        if (newVal) {
          this.totalContentAmount = this.calculateTotalContentAmount(newVal);
        }
      },
      deep: true
    },
  }
}
</script>
